import React, { useState } from 'react';
import { resolveGeoBrandLogoUrl } from '../constants/geoBrandAliases';

export function getBrandInitials(name) {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join('')
    .toUpperCase() || '?';
}

/**
 * Brand logo from API (official site favicon) with colored-initials fallback.
 */
export default function GeoBrandLogo({
  name,
  color,
  logoUrl = null,
  size = 22,
  className = '',
  isClient = false,
}) {
  const [failed, setFailed] = useState(false);
  const resolvedLogoUrl = logoUrl || resolveGeoBrandLogoUrl(name, { size: Math.max(32, size * 2) });
  const showImage = Boolean(resolvedLogoUrl) && !failed;
  const sizePx = `${size}px`;
  const fontSize = Math.max(3, Math.round(size * 0.38));

  if (showImage) {
    return (
      <img
        src={resolvedLogoUrl}
        alt={name}
        title={name}
        width={size}
        height={size}
        className={`geo-brand-logo-img ${className}${isClient ? ' geo-brand-logo-img--client' : ''}`}
        style={{ width: sizePx, height: sizePx }}
        loading="lazy"
        decoding="async"
        onError={() => setFailed(true)}
      />
    );
  }

  return (
    <span
      className={`geo-brand-avatar ${className}${isClient ? ' geo-brand-avatar--client' : ''}`}
      style={{
        background: color,
        width: sizePx,
        height: sizePx,
        fontSize: `${fontSize}px`,
        borderRadius: Math.max(1, size * 0.2),
      }}
      title={name}
      aria-hidden={!name}
    >
      {getBrandInitials(name)}
    </span>
  );
}
